import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent } from "@/components/ui/card";

const MainPageSkeleton: React.FC = () => {
    return (
        <div className="flex h-screen w-full">
            {/* Sidebar */}
            <aside className="hidden md:flex w-[260px] flex-col border-r bg-muted/20 p-4">
                <Skeleton className="h-6 w-[70%] mb-6" />

                <div className="space-y-3">
                    <Skeleton className="h-11 w-full rounded-xl" />
                    <Skeleton className="h-11 w-full rounded-xl" />
                    <Skeleton className="h-11 w-full rounded-xl" />
                    <Skeleton className="h-11 w-full rounded-xl" />
                </div>

                <div className="mt-auto pt-6">
                    <Skeleton className="h-11 w-full rounded-xl" />
                </div>
            </aside>

            {/* Main */}
            <div className="flex min-w-0 flex-1 flex-col">
                {/* Topbar */}
                <header className="flex h-14 items-center gap-3 border-b bg-background px-4">
                    <Skeleton className="h-6 w-[180px]" />
                    <div className="ml-auto flex items-center gap-3">
                        <Skeleton className="h-9 w-28 rounded-xl" />
                        <Skeleton className="h-9 w-9 rounded-full" />
                    </div>
                </header>

                {/* Content */}
                <main className="flex-1 overflow-auto p-4 sm:p-6">
                    <div className="mb-6 space-y-2">
                        <Skeleton className="h-8 w-[40%]" />
                        <Skeleton className="h-4 w-[55%]" />
                    </div>

                    <Card className="overflow-hidden">
                        <CardContent className="p-4 sm:p-5 space-y-4">
                            {/* Filters row */}
                            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                                <Skeleton className="h-9 w-full sm:w-[280px] rounded-xl" />
                                <div className="flex gap-2">
                                    <Skeleton className="h-9 w-28 rounded-xl" />
                                    <Skeleton className="h-9 w-36 rounded-xl" />
                                </div>
                            </div>

                            {/* Table header */}
                            <div className="grid grid-cols-6 gap-2 rounded-xl border bg-muted/20 p-3">
                                <Skeleton className="h-4 w-10" />
                                <Skeleton className="h-4 w-28" />
                                <Skeleton className="h-4 w-24 hidden md:block" />
                                <Skeleton className="h-4 w-24" />
                                <Skeleton className="h-4 w-24 hidden lg:block" />
                                <Skeleton className="h-4 w-16 justify-self-end" />
                            </div>

                            {/* Table rows */}
                            <div className="space-y-2">
                                {Array.from({ length: 6 }).map((_, i) => (
                                    <div
                                        key={i}
                                        className="grid grid-cols-6 items-center gap-2 rounded-xl border p-3"
                                    >
                                        <Skeleton className="h-4 w-4 rounded" />
                                        <div className="space-y-2">
                                            <Skeleton className="h-4 w-[160px]" />
                                            <Skeleton className="h-3 w-[110px] md:hidden" />
                                        </div>
                                        <Skeleton className="h-4 w-[120px] hidden md:block" />
                                        <Skeleton className="h-4 w-[90px]" />
                                        <Skeleton className="h-4 w-[120px] hidden lg:block" />
                                        <Skeleton className="h-8 w-8 rounded-xl justify-self-end" />
                                    </div>
                                ))}
                            </div>

                            {/* Pagination */}
                            <div className="flex items-center justify-between pt-2">
                                <Skeleton className="h-4 w-32" />
                                <div className="flex gap-2">
                                    <Skeleton className="h-9 w-24 rounded-xl" />
                                    <Skeleton className="h-9 w-24 rounded-xl" />
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </main>
            </div>
        </div>
    );
};

export default MainPageSkeleton;
